import React, { useState } from 'react';
import { TextField, Typography, Container, Grid, Button, Alert } from '@mui/material';
import Navbar from './Navbar';

const ReservationPage = ({ isLocked }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [partySize, setPartySize] = useState(1);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    // Mock createReservation function
    const createReservation = async (reservationData) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                console.log('Reservation data sent to backend:', reservationData);
                resolve();
            }, 1000); // Simulate a 1-second delay
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (isLocked) {
            // Simulate a successful submission without sending data to the backend
            setTimeout(() => {
                setMessage('Reservation successful! (Locked Mode: Data not sent to backend)');
                setLoading(false);
                resetForm();
            }, 1000);
            return;
        }

        try {
            await createReservation({
                name,
                email,
                phone,
                date,
                time,
                partySize,
            });
            setMessage('Reservation successful!');
            resetForm();
        } catch (error) {
            setMessage('Failed to make a reservation. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setName('');
        setEmail('');
        setPhone('');
        setDate('');
        setTime('');
        setPartySize(1);
    };

    return (
        <>
            <Navbar />
            <Container>
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                        fontFamily: "'Brilon', sans-serif",
                        textAlign: 'center',
                        marginBottom: '20px',
                        marginTop: '20px',
                    }}
                >
                    Make a Reservation
                </Typography>
                {message && (
                    <Alert severity="info" sx={{ marginBottom: '20px', fontFamily: "'Brilon', sans-serif" }}>
                        {message}
                    </Alert>
                )}
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                fullWidth
                                required
                                margin="normal"
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputLabelProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                fullWidth
                                required
                                margin="normal"
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputLabelProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                fullWidth
                                required
                                margin="normal"
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputLabelProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Party Size"
                                type="number"
                                value={partySize}
                                onChange={(e) => setPartySize(e.target.value)}
                                fullWidth
                                required
                                margin="normal"
                                inputProps={{ min: 1 }}
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputLabelProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Date"
                                type="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                fullWidth
                                required
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Time"
                                type="time"
                                value={time}
                                onChange={(e) => setTime(e.target.value)}
                                fullWidth
                                required
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{
                                    marginTop: '20px',
                                    fontFamily: "'Brilon', sans-serif",
                                    backgroundColor: '#614a94',
                                    '&:hover': {
                                        backgroundColor: '#4a3573',
                                    },
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Submitting...' : 'Submit'}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Container>
        </>
    );
};

export default ReservationPage;